var e = /* @__PURE__ */ ((o) => (o.nextMonth = "nextMonth", o.previousMonth = "previousMonth", o.YearSelector = "YearSelector", o.openMonthSelector = "openMonthSelector", o.openYearSelector = "openYearSelector", o.closeMonthSelector = "closeMonthSelector", o.closeYearSelector = "closeYearSelector", o.from = "from", o.to = "to", o.placeholder = "placeholder", o.label = "labelProp.label", o.clearButton = "clearButton", o))(e || {});
const t = {
  [e.nextMonth]: "Další měsíc",
  [e.previousMonth]: "Předchozí měsíc",
  [e.openMonthSelector]: "Otevřít výběr měsíce",
  [e.openYearSelector]: "Otevřít výběr roku",
  [e.closeMonthSelector]: "Zavřít výběr měsíce",
  [e.closeYearSelector]: "Zavřít výběr roku",
  [e.from]: "od",
  [e.to]: "do",
  [e.placeholder]: "DD / MM / RRRR",
  [e.label]: "Vyberte datum",
  [e.clearButton]: "Vymazat tlačítko",
  [e.YearSelector]: "Rokový výběr"
}, r = {
  [e.nextMonth]: "Næste måned",
  [e.previousMonth]: "Forrige måned",
  [e.openMonthSelector]: "Åbn månedsselector",
  [e.openYearSelector]: "Åbn årselector",
  [e.closeMonthSelector]: "Luk månedsselector",
  [e.closeYearSelector]: "Luk årselector",
  [e.from]: "fra",
  [e.to]: "til",
  [e.placeholder]: "DD / MM / ÅÅÅÅ",
  [e.label]: "Vælg en dato",
  [e.clearButton]: "Ryd knap",
  [e.YearSelector]: "Årselector"
}, l = {
  [e.nextMonth]: "Nächster Monat",
  [e.previousMonth]: "Vorheriger Monat",
  [e.openMonthSelector]: "Monatsauswahl öffnen",
  [e.openYearSelector]: "Jahresauswahl öffnen",
  [e.closeMonthSelector]: "Monatsauswahl schließen",
  [e.closeYearSelector]: "Jahresauswahl schließen",
  [e.from]: "von",
  [e.to]: "bis",
  [e.placeholder]: "TT / MM / JJJJ",
  [e.label]: "Datum auswählen",
  [e.clearButton]: "Löschen Schaltfläche",
  [e.YearSelector]: "Jahresauswahl"
}, n = {
  [e.nextMonth]: "Nächster Monat",
  [e.previousMonth]: "Vorheriger Monat",
  [e.openMonthSelector]: "Monatsauswahl öffnen",
  [e.openYearSelector]: "Jahresauswahl öffnen",
  [e.closeMonthSelector]: "Monatsauswahl schließen",
  [e.closeYearSelector]: "Jahresauswahl schließen",
  [e.from]: "von",
  [e.to]: "bis",
  [e.placeholder]: "TT / MM / JJJJ",
  [e.label]: "Datum auswählen",
  [e.clearButton]: "Löschen Schaltfläche",
  [e.YearSelector]: "Jahresauswahl"
}, a = {
  [e.nextMonth]: "Επόμενος μήνας",
  [e.previousMonth]: "Προηγούμενος μήνας",
  [e.openMonthSelector]: "Άνοιγμα επιλογέα μήνα",
  [e.openYearSelector]: "Άνοιγμα επιλογέα έτους",
  [e.closeMonthSelector]: "Κλείσιμο επιλογέα μήνα",
  [e.closeYearSelector]: "Κλείσιμο επιλογέα έτους",
  [e.from]: "από",
  [e.to]: "έως",
  [e.placeholder]: "ΗΗ / ΜΜ / ΕΕΕΕ",
  [e.label]: "Επιλέξτε ημερομηνία",
  [e.clearButton]: "Καθαρισμός κουμπί",
  [e.YearSelector]: "Επιλογή έτους"
}, c = {
  [e.nextMonth]: "Next Month",
  [e.previousMonth]: "Previous Month",
  [e.openMonthSelector]: "Open Month Selector",
  [e.openYearSelector]: "Open Year Selector",
  [e.closeMonthSelector]: "Close Month Selector",
  [e.closeYearSelector]: "Close Year Selector",
  [e.from]: "from",
  [e.to]: "to",
  [e.placeholder]: "MM / DD / YYYY",
  [e.label]: "Select Date",
  [e.clearButton]: "Clear Button",
  [e.YearSelector]: "Year Selector"
}, s = {
  [e.nextMonth]: "Next Month",
  [e.previousMonth]: "Previous Month",
  [e.openMonthSelector]: "Open Month Selector",
  [e.openYearSelector]: "Open Year Selector",
  [e.closeMonthSelector]: "Close Month Selector",
  [e.closeYearSelector]: "Close Year Selector",
  [e.from]: "from",
  [e.to]: "to",
  [e.placeholder]: "MM / DD / YYYY",
  [e.label]: "Select Date",
  [e.clearButton]: "Clear Button",
  [e.YearSelector]: "Year Selector"
}, h = {
  [e.nextMonth]: "Next Month",
  [e.previousMonth]: "Previous Month",
  [e.openMonthSelector]: "Open Month Selector",
  [e.openYearSelector]: "Open Year Selector",
  [e.closeMonthSelector]: "Close Month Selector",
  [e.closeYearSelector]: "Close Year Selector",
  [e.from]: "from",
  [e.to]: "to",
  [e.placeholder]: "MM / DD / YYYY",
  [e.label]: "Select Date",
  [e.clearButton]: "Clear Button",
  [e.YearSelector]: "Year Selector"
}, S = {
  [e.nextMonth]: "Next Month",
  [e.previousMonth]: "Previous Month",
  [e.openMonthSelector]: "Open Month Selector",
  [e.openYearSelector]: "Open Year Selector",
  [e.closeMonthSelector]: "Close Month Selector",
  [e.closeYearSelector]: "Close Year Selector",
  [e.from]: "from",
  [e.to]: "to",
  [e.placeholder]: "MM / DD / YYYY",
  [e.label]: "Select Date",
  [e.clearButton]: "Clear Button",
  [e.YearSelector]: "Year Selector"
}, M = {
  [e.nextMonth]: "Mes siguiente",
  [e.previousMonth]: "Mes anterior",
  [e.openMonthSelector]: "Abrir selector de mes",
  [e.openYearSelector]: "Abrir selector de año",
  [e.closeMonthSelector]: "Cerrar selector de mes",
  [e.closeYearSelector]: "Cerrar selector de año",
  [e.from]: "desde",
  [e.to]: "hasta",
  [e.placeholder]: "DD / MM / AAAA",
  [e.label]: "Seleccionar una fecha",
  [e.clearButton]: "Botón de borrar",
  [e.YearSelector]: "Selector de año"
}, i = {
  [e.nextMonth]: "Mes siguiente",
  [e.previousMonth]: "Mes anterior",
  [e.openMonthSelector]: "Abrir selector de mes",
  [e.openYearSelector]: "Abrir selector de año",
  [e.closeMonthSelector]: "Cerrar selector de mes",
  [e.closeYearSelector]: "Cerrar selector de año",
  [e.from]: "desde",
  [e.to]: "hasta",
  [e.placeholder]: "DD / MM / AAAA",
  [e.label]: "Seleccionar una fecha",
  [e.clearButton]: "Botón de borrar",
  [e.YearSelector]: "Selector de año"
}, u = {
  [e.nextMonth]: "Seuraava kuukausi",
  [e.previousMonth]: "Edellinen kuukausi",
  [e.openMonthSelector]: "Avaa kuukauden valitsin",
  [e.openYearSelector]: "Avaa vuoden valitsin",
  [e.closeMonthSelector]: "Sulje kuukauden valitsin",
  [e.closeYearSelector]: "Sulje vuoden valitsin",
  [e.from]: "alkaen",
  [e.to]: "asti",
  [e.placeholder]: "PP / KK / VVVV",
  [e.label]: "Valitse päivämäärä",
  [e.clearButton]: "Tyhjennä painike",
  [e.YearSelector]: "Vuoden valitsin"
}, p = {
  [e.nextMonth]: "Mois suivant",
  [e.previousMonth]: "Mois précédent",
  [e.openMonthSelector]: "Ouvrir le sélecteur de mois",
  [e.openYearSelector]: "Ouvrir le sélecteur d'année",
  [e.closeMonthSelector]: "Fermer le sélecteur de mois",
  [e.closeYearSelector]: "Fermer le sélecteur d'année",
  [e.from]: "de",
  [e.to]: "à",
  [e.placeholder]: "JJ / MM / AAAA",
  [e.label]: "Sélectionner une date",
  [e.clearButton]: "Bouton effacer",
  [e.YearSelector]: "Sélecteur d'année"
}, d = {
  [e.nextMonth]: "Volgende maand",
  [e.previousMonth]: "Vorige maand",
  [e.openMonthSelector]: "Open de maandselector",
  [e.openYearSelector]: "Open het jaartalselector",
  [e.closeMonthSelector]: "Sluit de maandselector",
  [e.closeYearSelector]: "Sluit het jaartalselector",
  [e.from]: "van",
  [e.to]: "tot",
  [e.placeholder]: "JJ / MM / AAAA",
  [e.label]: "Selecteer een datum",
  [e.clearButton]: "Wissen knop",
  [e.YearSelector]: "Jaartalselector"
}, Y = {
  [e.nextMonth]: "Mois suivant",
  [e.previousMonth]: "Mois précédent",
  [e.openMonthSelector]: "Ouvrir le sélecteur de mois",
  [e.openYearSelector]: "Ouvrir le sélecteur d'année",
  [e.closeMonthSelector]: "Fermer le sélecteur de mois",
  [e.closeYearSelector]: "Fermer le sélecteur d'année",
  [e.from]: "de",
  [e.to]: "à",
  [e.placeholder]: "JJ / MM / AAAA",
  [e.label]: "Sélectionner une date",
  [e.clearButton]: "Effacer le bouton",
  [e.YearSelector]: "Sélecteur d'année"
}, m = {
  [e.nextMonth]: "Mois suivant",
  [e.previousMonth]: "Mois précédent",
  [e.openMonthSelector]: "Ouvrir le sélecteur de mois",
  [e.openYearSelector]: "Ouvrir le sélecteur d'année",
  [e.closeMonthSelector]: "Fermer le sélecteur de mois",
  [e.closeYearSelector]: "Fermer le sélecteur d'année",
  [e.from]: "de",
  [e.to]: "à",
  [e.placeholder]: "JJ / MM / AAAA",
  [e.label]: "Sélectionner une date",
  [e.clearButton]: "Effacer le bouton",
  [e.YearSelector]: "Sélecteur d'année"
}, v = {
  [e.nextMonth]: "Következő hónap",
  [e.previousMonth]: "Előző hónap",
  [e.openMonthSelector]: "Hónap kiválasztása",
  [e.openYearSelector]: "Év kiválasztása",
  [e.closeMonthSelector]: "Hónap kiválasztás bezárása",
  [e.closeYearSelector]: "Év kiválasztás bezárása",
  [e.from]: "tól",
  [e.to]: "ig",
  [e.placeholder]: "HH / NN / ÉÉÉÉ",
  [e.label]: "Válassz dátumot",
  [e.clearButton]: "Törlés gomb",
  [e.YearSelector]: "Év kiválasztó"
}, A = {
  [e.nextMonth]: "Mese successivo",
  [e.previousMonth]: "Mese precedente",
  [e.openMonthSelector]: "Apri selettore del mese",
  [e.openYearSelector]: "Apri selettore dell'anno",
  [e.closeMonthSelector]: "Chiudi selettore del mese",
  [e.closeYearSelector]: "Chiudi selettore dell'anno",
  [e.from]: "Da",
  [e.to]: "A",
  [e.placeholder]: "GG / MM / AAAA",
  [e.label]: "Seleziona una data",
  [e.clearButton]: "Pulsante di cancellazione",
  [e.YearSelector]: "Selettore dell'anno"
}, f = {
  [e.nextMonth]: "Volgende maand",
  [e.previousMonth]: "Vorige maand",
  [e.openMonthSelector]: "Open maandselector",
  [e.openYearSelector]: "Open jaarselector",
  [e.closeMonthSelector]: "Sluit maandselector",
  [e.closeYearSelector]: "Sluit jaarselector",
  [e.from]: "Van",
  [e.to]: "Tot",
  [e.placeholder]: "DD / MM / JJJJ",
  [e.label]: "Selecteer een datum",
  [e.clearButton]: "Wissen knop",
  [e.YearSelector]: "Jaarselector"
}, b = {
  [e.nextMonth]: "Neste måned",
  [e.previousMonth]: "Forrige måned",
  [e.openMonthSelector]: "Åpne månedvelger",
  [e.openYearSelector]: "Åpne årvelger",
  [e.closeMonthSelector]: "Lukk månedvelger",
  [e.closeYearSelector]: "Lukk årvelger",
  [e.from]: "Fra",
  [e.to]: "Til",
  [e.placeholder]: "DD / MM / ÅÅÅÅ",
  [e.label]: "Velg en dato",
  [e.clearButton]: "Ryddeknapp",
  [e.YearSelector]: "Årvelger"
}, k = {
  [e.nextMonth]: "Następny miesiąc",
  [e.previousMonth]: "Poprzedni miesiąc",
  [e.openMonthSelector]: "Otwórz selektor miesiąca",
  [e.openYearSelector]: "Otwórz selektor roku",
  [e.closeMonthSelector]: "Zamknij selektor miesiąca",
  [e.closeYearSelector]: "Zamknij selektor roku",
  [e.from]: "Od",
  [e.to]: "Do",
  [e.placeholder]: "DD / MM / RRRR",
  [e.label]: "Wybierz datę",
  [e.clearButton]: "Przycisk wyczyść",
  [e.YearSelector]: "Selektor roku"
}, B = {
  [e.nextMonth]: "Próximo mês",
  [e.previousMonth]: "Mês anterior",
  [e.openMonthSelector]: "Abrir seletor de mês",
  [e.openYearSelector]: "Abrir seletor de ano",
  [e.closeMonthSelector]: "Fechar seletor de mês",
  [e.closeYearSelector]: "Fechar seletor de ano",
  [e.from]: "De",
  [e.to]: "Para",
  [e.placeholder]: "DD / MM / AAAA",
  [e.label]: "Selecione uma data",
  [e.clearButton]: "Botão limpar",
  [e.YearSelector]: "Seletor de ano"
}, D = {
  [e.nextMonth]: "Luna următoare",
  [e.previousMonth]: "Luna precedentă",
  [e.openMonthSelector]: "Deschide selectorul de lună",
  [e.openYearSelector]: "Deschide selectorul de an",
  [e.closeMonthSelector]: "Închide selectorul de lună",
  [e.closeYearSelector]: "Închide selectorul de an",
  [e.from]: "De la",
  [e.to]: "La",
  [e.placeholder]: "ZZ / LL / AAAA",
  [e.label]: "Selectează o dată",
  [e.clearButton]: "Buton de ștergere",
  [e.YearSelector]: "Selector de an"
}, x = {
  [e.nextMonth]: "Nästa månad",
  [e.previousMonth]: "Föregående månad",
  [e.openMonthSelector]: "Öppna månadsval",
  [e.openYearSelector]: "Öppna årsväljare",
  [e.closeMonthSelector]: "Stäng månadsval",
  [e.closeYearSelector]: "Stäng årsväljare",
  [e.from]: "Från",
  [e.to]: "Till",
  [e.placeholder]: "DD / MM / ÅÅÅÅ",
  [e.label]: "Välj ett datum",
  [e.clearButton]: "Rensa knapp",
  [e.YearSelector]: "Årsväljare"
}, J = {
  [e.nextMonth]: "Sonraki Ay",
  [e.previousMonth]: "Önceki Ay",
  [e.openMonthSelector]: "Ay Seçiciyi Aç",
  [e.openYearSelector]: "Yıl Seçiciyi Aç",
  [e.closeMonthSelector]: "Ay Seçiciyi Kapat",
  [e.closeYearSelector]: "Yıl Seçiciyi Kapat",
  [e.from]: "Başlangıç",
  [e.to]: "Bitiş",
  [e.placeholder]: "GG / AA / YYYY",
  [e.label]: "Tarih Seç",
  [e.clearButton]: "Temizle Butonu",
  [e.YearSelector]: "Yıl Seçici"
};
export {
  t as cs,
  r as da,
  l as de,
  n as deAT,
  a as el,
  c as en,
  s as enCA,
  h as enGB,
  S as enUS,
  M as es,
  i as esMX,
  u as fi,
  p as fr,
  d as frBE,
  Y as frCA,
  m as frCh,
  v as hu,
  A as it,
  f as nl,
  b as no,
  k as pl,
  B as pt,
  D as ro,
  x as sv,
  J as tr
};
